import { Trans, useTranslation } from 'next-i18next';

import { sellerHelpUrl } from '@/shared/constants/routes';
import { useLocale } from '@/shared/hooks/useLocale';

import { LearnMoreLink } from '../../components/LearnMoreLink';
import { getFAQs } from './helpers';
import { FAQItem } from './components/FAQItem';
import { StrongBrandContainer } from '../../components/StrongBrandContainer';

export const FAQ = () => {
  const { t } = useTranslation();
  const { isoLocale } = useLocale();

  return (
    <div className="u-wrapper u-p-b-xl">
      <section className="u-m-t-xxl-18 tw:relative">
        <div className="tw:flex tw:justify-between tw:items-center u-m-b-xxl-10">
          <h2 className="u-typography-h2">
            <Trans
              i18nKey="seller_register.faq.title"
              components={{
                strong: (
                  <StrongBrandContainer className="u-typography-h2-serif" />
                ),
              }}
            />
          </h2>
          <LearnMoreLink
            className="tw:hidden tw:md:inline-flex"
            text={t('seller_register.faq.visit_help_centre')}
            url={sellerHelpUrl}
          />
        </div>

        {getFAQs(t, isoLocale).map(({ title, content, link }) => (
          <FAQItem key={title} title={title} text={content} link={link} />
        ))}

        <h6 className="u-typography-h6 u-m-t-xxl-10">
          {t('seller_register.faq.footnote')}
        </h6>
        <LearnMoreLink
          className="tw:md:hidden"
          text={t('seller_register.faq.visit_help_centre')}
          url={sellerHelpUrl}
        />
      </section>
    </div>
  );
};
